export default __webpack_public_path__ + "static/1-7bd09de4cd0f8a5c6ffa472f7b57264f.jpeg";